angular.module('angus.filters').filter('forPropertyEquals',['_', function(_) {
	'use strict';

    return function(listToSelectFrom, propertyName, value) {    	
        return  _.filter(listToSelectFrom, function(listItem) {
            return listItem[propertyName] == value;
        });
    };
}]);